const bestFitColumnSize = items => {
  if (!items) {
    return 0;
  }
  if (!Array.isArray(items)) {
    return 12;
  }
  const itemsCount = items.filter(x => x).length;
  if (itemsCount) {
    return 12 / itemsCount;
  }
  return 0;
};
export { bestFitColumnSize };